import { render } from "./sidebar-menu.vue?vue&type=template&id=4e206528"
import script from "./sidebar-menu.vue?vue&type=script&lang=js"
export * from "./sidebar-menu.vue?vue&type=script&lang=js"

import "./sidebar-menu.vue?vue&type=style&index=0&id=4e206528&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__